module.exports = __webpack_public_path__ + "static/img/loading.71ce664.gif";


//////////////////
// WEBPACK FOOTER
// ./static/images/loading.gif
// module id = 4cF/
// module chunks = 1